import React from 'react';
import { array, bool, func, object, } from 'prop-types';

import LoadingState from '../../../LoadingState';
import HealthRecordList from '../HealthRecordList';

import s from './HealthRecordListContainer.css';

/*
  We use a container here to separate loading state and "No Records available" state.
  This pattern is applied to Messages as well.
*/
const HealthRecordListContainer = ({ ...props }) => {
  
  const getHealthRecordList = () => {
    if (props.loadingAllRecords) {
      return (
        <div className={s.message}>
          <p>
            Fetching your health records...
          </p>
          <LoadingState context="healthRecordListContainer" />
        </div>
      );
    } else {
      return (
        <HealthRecordList
          healthRecordHeaders={props.healthRecordHeaders}
          handleTransmitForm={props.handleTransmitForm}
          selectedHealthRecordListItem={props.selectedHealthRecordListItem}
          handleViewRecord={props.handleViewRecord}
        />
      );
    }
  };

  return (
    <section className={s.component}>
      {getHealthRecordList()}
    </section>
  );

};

HealthRecordListContainer.propTypes = {
  loadingAllRecords: bool,
  healthRecordHeaders: array,
  handleTransmitForm: func,
  handleViewRecord: func,
  selectedHealthRecordListItem: object,
};

export default HealthRecordListContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthRecordListContainer/HealthRecordListContainer.js